// src/components/About.js
import React, { useEffect, useState, useRef } from "react";
import AmenitiesModal from "../modals/AmenitiesModal";
import CustomDropdown from "../../components/common/CustomDropdown";
import axios from "axios";

const PropertyDetailForm = ({
  listingId = null,
  activeStep,
  emitterEvent,
  errors,
  formData,
  handleInputDelete,
  handleInputChange,
  handleNextStep,
  handleSubmit,
  projectInput,
  setProjectInput,
  navigate,
  projects,
  loadingProjects,
  onSelectProject,
  selectedProject,
  localityInput,
  setLocalityInput,
  localities,
  loadingLocalities,
  propertyType,
  propertyService,
  selfType,
  handleEmitter,
}) => {
  const [showProjectDropdown, setShowProjectDropdown] = useState(false);
  const [showLocalityDropdown, setShowLocalityDropdown] = useState(false);
  const [rooms, setRooms] = useState(() => {
    const details = formData?.roomDetail;
    if (details && Object.keys(details).length > 0) {
      return Object.entries(details).map(([key, value]) => ({
        id: parseInt(key),
        rent: value.pricing || "",
        deposit: value.security_deposit_amount || "",
        type: value.pg_room_type || "",
      }));
    } else {
      return [{ id: 1, rent: "", deposit: "", type: "" }];
    }
  });
  const token = localStorage.getItem("authToken");

  const [newProject, setNewProject] = useState("");

  const roomTypes = [
    "Private Room",
    "Double Sharing",
    "Triple Sharing",
    "3+ Sharing",
  ];

  const addRoom = () => {
    setRooms([
      ...rooms,
      { id: rooms.length + 1, rent: "", deposit: "", type: "" },
    ]);
    handleInputChange("roomDetail", "pg_room_type", "", rooms.length + 1);
    handleInputChange("roomDetail", "pricing", "", rooms.length + 1);
    handleInputChange(
      "roomDetail",
      "security_deposit_amount",
      "",
      rooms.length + 1
    );
  };

  const removeRoom = (id: number) => {
    setRooms(rooms.filter((room) => room.id !== id));
    handleInputDelete("roomDetail", id);
  };

  const sellPropertyType = [
    { value: "apartment", label: "Apartment" },
    { value: "independent_floor", label: "Independent Floor" },
    { value: "independent_house", label: "Independent House" },
    { value: "villa", label: "Villa" },
    { value: "plot", label: "Plot" },
    { value: "agricultural_land", label: "Agricultural Land" },
  ];
  const rentPropertyType = [
    { value: "apartment", label: "Apartment" },
    { value: "independent_floor", label: "Independent Floor" },
    { value: "independent_house", label: "Independent House" },
    { value: "villa", label: "Villa" },
  ];
  const commercialPropertyType = [
    { value: "office", label: "Office" },
    { value: "retailshop", label: "Retail Shop" },
    { value: "showroom", label: "Showroom" },
    { value: "warehouse", label: "WareHouse" },
    { value: "plot", label: "Plot" },
    { value: "other", label: "Others" },
  ];
  const furnishType = [
    { value: "1", label: "Fully Furnished" },
    { value: "2", label: "Semi Furnished" },
    { value: "3", label: "UnFurnished" },
  ];
  const bhkOption = [
    { value: "1", label: "1 BHK" },
    { value: "2", label: "2 BHK" },
    { value: "3", label: "3 BHK" },
    { value: "4", label: "4 BHK" },
    { value: "5", label: "5 BHK" },
    { value: "6", label: "6 BHK" },
    { value: "7", label: "7 BHK" },
    { value: "8", label: "8 BHK" },
    { value: "9", label: "9 BHK" },
    { value: "10", label: "10 BHK" },
  ];
  const areaUnitOption = [
    { value: "sq.ft.", label: "sq.ft." },
    { value: "sq.yd.", label: "sq.yd." },
    { value: "sq.mt.", label: "sq.mt." },
  ];
  const possessionStatusOption = [
    { value: "ready_to_use", label: "Ready To Move" },
    { value: "under_construction", label: "Under Construction" },
  ];
  const constructionOption = [
    { value: "ready_to_move", label: "Ready To Move" },
    { value: "under_construction", label: "Under Construction" },
  ];
  const zoneTypeOption = [
    { value: "industrial", label: "Industrial" },
    { value: "commercial", label: "Commercial" },
    { value: "residential", label: "Residential" },
    { value: "economic", label: "Special Economic Zone" },
    { value: "open_space", label: "Open Space" },
    { value: "agricultural", label: "Agricultural Zone" },
    { value: "other", label: "Others" },
  ];
  const ownershipOption = [
    { value: "freehold", label: "Freehold" },
    { value: "leasehold", label: "Leasehold" },
    { value: "cooperative_society", label: "Cooperative Society" },
    { value: "power_attorney", label: "Power of attorney" },
  ];
  const locationHubOption = [
    { value: "it_park", label: "IT Park" },
    { value: "business_park", label: "Business Park" },
    { value: "others", label: "Others" },
  ];
  const propertyConditionOption = [
    { value: "ready_use", label: "Ready to Use" },
    { value: "bare_shell", label: "Bare shell" },
  ];
  const constructionStatusOption = [
    { value: "No Wall", label: "No Walls" },
    { value: "Bricks Walls", label: "Brick Walls" },
    { value: "Cemented Walls", label: "Cemented Walls" },
    { value: "Plastered Walls", label: "Plaster Walls" },
  ];
  const locationHub2Option = [
    { value: "mall", label: "Mall" },
    { value: "commercial", label: "Commercial Project" },
    { value: "residential_project", label: "Residential Project" },
    { value: "complex_building", label: "Retail Complex/Building" },
    { value: "market_street", label: "Market/High Street" },
    { value: "others", label: "Others" },
  ];
  const securityDepositOption = [
    { value: "0", label: "None" },
    { value: "1", label: "1 Month" },
    { value: "2", label: "2 Month" },
    { value: "3", label: "3 Month" },
    { value: "custom", label: "Custom" },
  ];

  const pgOption = [
    { value: "girl", label: "Girls" },
    { value: "boy", label: "Boys" },
  ];

  const suitedOption = [
    { value: "students", label: "Students" },
    { value: "professionals", label: "Professionals" },
  ];

  const mealAvailableOption = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const mealOfferingOption = [
    { value: "breakfast", label: "BreakFast" },
    { value: "lunch", label: "Lunch" },
    { value: "dinner", label: "Dinner" },
  ];

  const commonAreaOption = [
    { value: "living_room", label: "Living Room" },
    { value: "kitchen", label: "Kitchen" },
    { value: "dinning_hall", label: "Dinning Hall" },
    { value: "study_room", label: "Study Room/ Library" },
    { value: "breakout_room", label: "Breakout Room" },
  ];

  const mealSpecialityOption = [
    { value: "punjabi", label: "Punjabi" },
    { value: "south_indian", label: "South Indian" },
    { value: "andhra", label: "Andhra" },
    { value: "north_indian", label: "North Indian" },
    { value: "others", label: "Others" },
  ];

  const roomTypeOption = [
    { value: "0", label: "Private Room" },
    { value: "1", label: "Double Room" },
    { value: "2", label: "Triple Sharing" },
    { value: "3", label: "3+ Sharing" },
  ];

  const transactionType = [
    { value: "new_booking", label: "New Booking" },
    { value: "resale", label: "Resale" },
  ];

  const yesNoOption = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
  ];

  const maintenanceOption = [
    { value: "include_in_rent", label: "Include in rent" },
    { value: "seprate", label: "Seprate" },
  ];

  const lockPeriodOption = [
    { value: "0", label: "None" },
    { value: "1", label: "1 month" },
    { value: "6", label: "6 month" },
    { value: "custom", label: "Custom" },
  ];

  const brokerageOption = [
    { value: "0", label: "None" },
    { value: "15", label: "15 Days" },
    { value: "30", label: "30 Days" },
    { value: "custom", label: "Custom" },
  ];
  const flooringOption = [
    { value: "marbel", label: "Marbel" },
    { value: "conrete", label: "Concrete" },
    { value: "granite", label: "Granite" },
    { value: "ceramic", label: "Ceramic" },
    { value: "cement", label: "Cement" },
    { value: "others", label: "Others" },
  ];
  const suitableOption = [
    { value: "jewellery", label: "Jewellery" },
    { value: "gym", label: "Gym" },
    { value: "grocery", label: "Grocery" },
    { value: "clinic", label: "Clinic" },
    { value: "footwear", label: "Footwear" },
    { value: "electronic", label: "Electronic" },
    { value: "clothing", label: "Clothing" },
    { value: "others", label: "Others" },
  ];

  // Handle input change and show dropdown
  const handleProjectInputChange = (e) => {
    setProjectInput(e.target.value);
    setShowProjectDropdown(true);
    setLocalityInput("");
    handleInputChange("propertyDetails", "sub_locality_id", "");
    handleInputChange("propertyDetails", "locality_id", "");
    handleInputChange("propertyDetails", "project_id", "");
  };

  // Handle project selection & hide dropdown
  const handleProjectSelect = (project) => {
    setProjectInput(project.name);
    onSelectProject(project);
    setLocalityInput(project.title);
    handleInputChange(
      "propertyDetails",
      "sub_locality_id",
      project.sub_location
    );
    handleInputChange("propertyDetails", "locality_id", project.location);
    handleInputChange("propertyDetails", "project_id", project.id);
    setShowProjectDropdown(false); // Hide dropdown after selection
  };

  // Handle Locality Input Change
  const handleLocalityInputChange = (e) => {
    setLocalityInput(e.target.value);
    setShowLocalityDropdown(true);
    handleInputChange("propertyDetails", "sub_locality_id", "");
    handleInputChange("propertyDetails", "locality_id", "");
  };

  // Handle Locality Selection & Hide Dropdown
  const handleLocalitySelect = (locality) => {
    // alert(JSON.stringify(locality));
    setLocalityInput(locality.title);
    handleInputChange("propertyDetails", "sub_locality_id", locality.id);
    handleInputChange("propertyDetails", "locality_id", locality.locality_id);
    setShowLocalityDropdown(false); // Hide dropdown after selection
  };

  const handleAddProjectSelect = async (project) => {
    //alert(project);
    setProjectInput(project);

    var propertyType = formData?.propertyDetails?.property_type || "Not Set";
    //alert(propertyType);
    let category = "";
    if (
      propertyType === "apartment" ||
      propertyType === "retailshop" ||
      propertyType === "office" ||
      propertyType === "showroom"
    ) {
      category = "Building";
    } else if (
      propertyType === "independent_house" ||
      propertyType === "villa" ||
      propertyType === "plot" ||
      propertyType === "agricultural_land" ||
      propertyType === "warehouse" ||
      propertyType === "other"
    ) {
      category = "Project";
    } else {
      category = "Society";
    }
    const projectData = {
      name: project,
      category: category,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/addProjects`,
        projectData, // Ensure formData is properly defined
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`, // Attach Bearer token
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        //alert(response.data.data.id);
        handleInputChange(
          "propertyDetails",
          "project_id",
          response.data.data.id
        );
      }
    } catch (error) {
      console.error("Error updating:", error);
      alert("Something Went Wrong. Please try again.");
    }

    setShowProjectDropdown(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    handleEmitter();
  };

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  };

  const prevBrokerageCharge = usePrevious(
    formData.propertyDetails.brokerage_charge
  );
  const prevLockPeriod = usePrevious(formData.propertyDetails.lock_period);
  const prevPgMealsAvailable = usePrevious(
    formData.propertyDetails.pg_meals_available
  );
  const prevPropertyCondition = usePrevious(
    formData.propertyDetails.property_condition
  );
  const prevPossessionStatus = usePrevious(
    formData.propertyDetails.possession_status
  );
  const prevLocationHub = usePrevious(formData.propertyDetails.location_hub);
  const prevSecurityDepositMonth = usePrevious(
    formData.propertyPrice.security_deposit_month
  );
  const prevConstructionStatus = usePrevious(
    formData.propertyPrice.construction_status
  );

  useEffect(() => {
    if (
      prevBrokerageCharge === "1" &&
      formData.propertyDetails.brokerage_charge !== "1"
    ) {
      handleInputChange("propertyDetails", "brokerage_amount", "");
      handleInputChange("propertyDetails", "brokerage_negotiable", "");
    }

    if (
      prevBrokerageCharge === "custom" &&
      formData.propertyDetails.brokerage_charge !== "custom"
    ) {
      handleInputChange("propertyDetails", "brokerage_amount", "");
    }

    if (
      prevLockPeriod === "custom" &&
      formData.propertyDetails.lock_period !== "custom"
    ) {
      handleInputChange("propertyDetails", "lock_period_amount", "");
    }

    if (
      prevPgMealsAvailable === "yes" &&
      formData.propertyDetails.pg_meals_available !== "yes"
    ) {
      handleInputChange("propertyDetails", "pg_meals_offering", "");
    }

    if (
      prevPropertyCondition === "ready_use" &&
      formData.propertyDetails.property_condition !== "ready_use"
    ) {
      handleInputChange("propertyDetails", "number_of_seats_input", "");
      handleInputChange("propertyDetails", "number_of_cabins_input", "");
      handleInputChange("propertyDetails", "number_of_meeting_rooms_input", "");
      handleInputChange("propertyDetails", "conference_room", "");
      handleInputChange("propertyDetails", "carpet_area", "");
    }

    if (
      prevPropertyCondition === "bare_shell" &&
      formData.propertyDetails.property_condition !== "bare_shell"
    ) {
      handleInputChange("propertyDetails", "construction_status", "");
      handleInputChange("propertyDetails", "flooring", "");
    }

    if (
      prevPossessionStatus === "ready_to_use" &&
      formData.propertyDetails.possession_status !== "ready_to_use"
    ) {
      handleInputChange("propertyDetails", "property_age", "");
    }

    if (
      prevPossessionStatus === "under_construction" &&
      formData.propertyDetails.possession_status !== "under_construction"
    ) {
      handleInputChange("propertyDetails", "possession_date", "");
    }

    if (
      prevLocationHub === "others" &&
      formData.propertyDetails.location_hub !== "others"
    ) {
      handleInputChange("propertyDetails", "other_location_hub", "");
    }

    if (
      prevSecurityDepositMonth === "custom" &&
      formData.propertyPrice.security_deposit_month !== "custom"
    ) {
      handleInputChange("propertyPrice", "security_deposit_amount", "");
    }

    if (
      prevConstructionStatus === "under_construction" &&
      formData.propertyPrice.construction_status !== "under_construction"
    ) {
      handleInputChange("propertyDetails", "possession_date", "");
    }
  }, [
    formData.propertyDetails.brokerage_charge,
    formData.propertyDetails.lock_period,
    formData.propertyDetails.pg_meals_available,
    formData.propertyDetails.property_condition,
    formData.propertyDetails.possession_status,
    formData.propertyDetails.location_hub,
    formData.propertyPrice.security_deposit_month,
    formData.propertyPrice.construction_status,
  ]);

  // Input field for role (Builder/Agent) in Residential Sell category
  if (
    selfType === 6 &&
    propertyType === "residential" &&
    propertyService === "sell"
  ) {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.property_type || errors.projectInput ? "mb-4" : "mb-4"
                }`}
              >
                <div className=" w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    required={"1"}
                    field={"property_type"}
                    options={sellPropertyType}
                    placeholder="Select Property Type"
                    onSelect={(value) => console.log("property type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
                <div className="input-container w-50">
                  <div className="autocomplete-container">
                    {/* Project Dropdown */}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="buildingInput"
                        placeholder=" "
                        value={projectInput}
                        onChange={handleProjectInputChange}
                        className="textField"
                      />
                      <label htmlFor="buildingInput" className="floating-label">
                        Building/Project/Society (Optional)
                      </label>
                    </div>

                    {loadingProjects && (
                      <div className="loading">Loading projects...</div>
                    )}

                    {showProjectDropdown && projectInput?.length >= 1 && (
                      <ul className="autocomplete-dropdown">
                        {projects.length === 0 ? ( // ✅ Only check for empty array
                          <li className="autocomplete-item no-results">
                            No results found
                            <button
                              className="add-new-btn"
                              // onClick={() => handleAddProjectSelect(projectInput)}
                              onClick={() =>
                                window.open("/addProject", "_blank")
                              }
                            >
                              + Add New
                            </button>
                          </li>
                        ) : (
                          projects.map((project) => (
                            <li
                              key={project.id}
                              className="autocomplete-item"
                              onClick={() => handleProjectSelect(project)}
                            >
                              {project.name}
                            </li>
                          ))
                        )}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              <div
                className={`formRow mt-4 ${
                  errors.sub_locality_id || errors.furnish_type
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="localityInput"
                      placeholder=" "
                      value={localityInput}
                      onChange={handleLocalityInputChange}
                      className="textField"
                    />
                    <label htmlFor="localityInput" className="floating-label">
                      Locality (Optional)
                    </label>
                  </div>

                  {loadingLocalities && (
                    <div className="loading">Loading localities...</div>
                  )}

                  {showLocalityDropdown && localities.length > 0 && (
                    <ul className="autocomplete-dropdown">
                      {localities.map((locality) => (
                        <li
                          key={locality.id}
                          className="autocomplete-item"
                          onClick={() => handleLocalitySelect(locality)}
                        >
                          {locality.title}
                        </li>
                      ))}
                    </ul>
                  )}

                  {errors.sub_locality_id && (
                    <small className="text-danger">
                      {errors.sub_locality_id}
                    </small>
                  )}
                </div>
                {[
                  "apartment",
                  "independent_floor",
                  "independent_house",
                  "villa",
                ].includes(formData.propertyDetails.property_type) && (
                  <div className="w-50">
                    <CustomDropdown
                      formData={formData}
                      handleInputChange={handleInputChange}
                      index={"propertyDetails"}
                      required={"1"}
                      field={"furnish_type"}
                      options={furnishType}
                      placeholder="Select Furnish Type"
                      onSelect={(value) => console.log("furnish type:", value)}
                    />
                    {errors.furnish_type && (
                      <small className="text-danger">
                        {errors.furnish_type}
                      </small>
                    )}
                  </div>
                )}
              </div>
              {[
                "apartment",
                "independent_floor",
                "independent_house",
                "villa",
              ].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.bhk || errors.buildup_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"bhk"}
                        options={bhkOption}
                        placeholder="Select BHK"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.bhk && (
                        <small className="text-danger">{errors.bhk}</small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft)
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.transaction_type || errors.maintenance_charge
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"transaction_type"}
                        options={transactionType}
                        placeholder="Transaction Type"
                        onSelect={(value) =>
                          console.log("transaction type:", value)
                        }
                      />
                      {errors.transaction_type && (
                        <small className="text-danger">
                          {errors.transaction_type}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="maintenanceCharge"
                        placeholder=" "
                        value={
                          formData.propertyDetails.maintenance_charge || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "maintenance_charge",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="maintenanceCharge"
                        className="floating-label"
                      >
                        Maintenance Charge (per month)
                      </label>
                      {errors.maintenance_charge && (
                        <small className="text-danger">
                          {errors.maintenance_charge}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.brokerage_charge || errors.carpet_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"brokerage_charge"}
                        options={yesNoOption}
                        placeholder="Do you charge brokerage"
                        onSelect={(value) =>
                          console.log("brokerage charge:", value)
                        }
                      />
                      {errors.brokerage_charge && (
                        <small className="text-danger">
                          {errors.brokerage_charge}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.)
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                  {["1"].includes(
                    formData.propertyDetails.brokerage_charge
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.brokerage_amount || errors.brokerage_negotiable
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="w-50">
                          <CustomDropdown
                            formData={formData}
                            handleInputChange={handleInputChange}
                            index={"propertyDetails"}
                            field={"brokerage_negotiable"}
                            options={yesNoOption}
                            placeholder="Brokerage Negotiable"
                            onSelect={(value) =>
                              console.log("brokerage negotiable:", value)
                            }
                          />
                          {errors.brokerage_negotiable && (
                            <small className="text-danger">
                              {errors.brokerage_negotiable}
                            </small>
                          )}
                        </div>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="brokerageAmount"
                            placeholder=" "
                            value={
                              formData.propertyDetails.brokerage_amount || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "brokerage_amount",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="brokerageAmount"
                            className="floating-label"
                          >
                            Brokerag (in Rupees)
                            <span className="required_field">*</span>
                          </label>
                          {errors.brokerage_amount && (
                            <small className="text-danger">
                              {errors.brokerage_amount}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              {["plot", "agricultural_land"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.plot_area || errors.area_unit ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="plotArea"
                        placeholder=" "
                        value={formData.propertyDetails.plot_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "plot_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="plotArea" className="floating-label">
                        Plot Area <span className="required_field">*</span>
                      </label>
                      {errors.plot_area && (
                        <small className="text-danger">
                          {errors.plot_area}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"area_unit"}
                        options={areaUnitOption}
                        placeholder="Select Area Unit"
                        required={"1"}
                        onSelect={(value) => console.log("area unit:", value)}
                      />
                      {errors.area_unit && (
                        <small className="text-danger">
                          {errors.area_unit}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.transaction_type || errors.maintenance_charge
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"transaction_type"}
                        options={transactionType}
                        placeholder="Transaction Type"
                        onSelect={(value) =>
                          console.log("transaction type:", value)
                        }
                      />
                      {errors.transaction_type && (
                        <small className="text-danger">
                          {errors.transaction_type}
                        </small>
                      )}
                    </div>
                    {/* <div className="input-container w-50">
                      <input
                        type="text"
                        id="maintenanceCharge"
                        placeholder=" "
                        value={formData.propertyDetails.maintenance_charge || ''}
                        onChange={(e) => handleInputChange('propertyDetails', 'maintenance_charge', e.target.value)}
                        onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                        className="textField"
                      />
                      <label htmlFor="maintenanceCharge" className="floating-label">
                        Maintenance Charge (per month)
                      </label>
                      {errors.maintenance_charge && <small className="text-danger">{errors.maintenance_charge}</small>}
                    </div> */}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.length || errors.width ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="length"
                        placeholder=" "
                        value={formData.propertyDetails.length || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "length",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="length" className="floating-label">
                        Length <span className="required_field">*</span>
                      </label>
                      {errors.length && (
                        <small className="text-danger">{errors.length}</small>
                      )}
                    </div>

                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="width"
                        placeholder=" "
                        value={formData.propertyDetails.width || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "width",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="width" className="floating-label">
                        Width <span className="required_field">*</span>
                      </label>
                      {errors.width && (
                        <small className="text-danger">{errors.width}</small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.brokerage_charge || errors.carpet_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"brokerage_charge"}
                        options={yesNoOption}
                        placeholder="Do you charge brokerage"
                        onSelect={(value) =>
                          console.log("brokerage charge:", value)
                        }
                      />
                      {errors.brokerage_charge && (
                        <small className="text-danger">
                          {errors.brokerage_charge}
                        </small>
                      )}
                    </div>
                  </div>
                  {["1"].includes(
                    formData.propertyDetails.brokerage_charge
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.brokerage_amount || errors.brokerage_negotiable
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="w-50">
                          <CustomDropdown
                            formData={formData}
                            handleInputChange={handleInputChange}
                            index={"propertyDetails"}
                            field={"brokerage_negotiable"}
                            options={yesNoOption}
                            placeholder="Brokerage Negotiable"
                            onSelect={(value) =>
                              console.log("brokerage negotiable:", value)
                            }
                          />
                          {errors.brokerage_negotiable && (
                            <small className="text-danger">
                              {errors.brokerage_negotiable}
                            </small>
                          )}
                        </div>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="brokerageAmount"
                            placeholder=" "
                            value={
                              formData.propertyDetails.brokerage_amount || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "brokerage_amount",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="brokerageAmount"
                            className="floating-label"
                          >
                            Brokerag (in Rupees){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.brokerage_amount && (
                            <small className="text-danger">
                              {errors.brokerage_amount}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
              <div className="cb">
                <input
                  type="checkbox"
                  checked={formData.propertyDetails.share_agent || false} // Ensure it's boolean
                  onChange={(e) =>
                    handleInputChange(
                      "propertyDetails",
                      "share_agent",
                      e.target.checked
                    )
                  }
                ></input>
                <span className="cb">
                  Share listing information with agents
                </span>
                {errors.share_agent && (
                  <small className="text-danger">{errors.share_agent}</small>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>

            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div
                className={`formRow mt-4 ${
                  errors.pricing || errors.construction_status ? "mb-5" : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <input
                    type="number"
                    id="pricing"
                    placeholder=" "
                    value={formData.propertyPrice.pricing || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyPrice",
                        "pricing",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pricing" className="floating-label">
                    Cost <span className="required_field">*</span>
                  </label>
                  {errors.pricing && (
                    <small className="text-danger">{errors.pricing}</small>
                  )}
                </div>
                <div className=" w-50 ">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"construction_status"}
                    options={constructionOption}
                    placeholder="Select Construction Status"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("construction status:", value)
                    }
                  />
                  {errors.construction_status && (
                    <small className="text-danger">
                      {errors.construction_status}
                    </small>
                  )}
                </div>
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.possession_date ? "mb-5" : "mb-3"
                }`}
              >
                {["under_construction"].includes(
                  formData.propertyDetails.construction_status
                ) && (
                  <>
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="propertyAge"
                        placeholder=" "
                        className="textField"
                        value={formData.propertyDetails.possession_date || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "possession_date",
                            e.target.value
                          )
                        }
                      />
                      <label htmlFor="propertyAge" className="floating-label">
                        Possession Date{" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.possession_date && (
                        <small className="text-danger">
                          {errors.possession_date}
                        </small>
                      )}
                    </div>
                  </>
                )}
              </div>

              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
  // Input field for role (Buy/Owner) in Residential Sell category
  else if (
    selfType === 5 &&
    propertyType === "residential" &&
    propertyService === "sell"
  ) {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.property_type || errors.projectInput ? "mb-4" : "mb-4"
                }`}
              >
                <div className=" w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_type"}
                    options={sellPropertyType}
                    placeholder="Select Property Type"
                    required={"1"}
                    onSelect={(value) => console.log("property type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
                <div className="input-container w-50">
                  <div className="autocomplete-container">
                    {/* Project Dropdown */}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="buildingInput"
                        placeholder=" "
                        // value={formData.propertyDetails.building || ''}
                        value={projectInput}
                        // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                        onChange={handleProjectInputChange}
                        className="textField"
                      />
                      <label htmlFor="buildingInput" className="floating-label">
                        Building/Project/Society (Optional)
                      </label>
                    </div>

                    {loadingProjects && (
                      <div className="loading">Loading projects...</div>
                    )}

                    {showProjectDropdown && projectInput?.length >= 1 && (
                      <ul className="autocomplete-dropdown">
                        {projects.length === 0 ? ( // ✅ Only check for empty array
                          <li className="autocomplete-item no-results">
                            No results found
                            {/* <button
                            className="add-new-btn"
                            // onClick={() => handleAddProjectSelect(projectInput)}
                            onClick={() => window.open('/addProject', '_blank')}
                          >
                            + Add New
                          </button> */}
                          </li>
                        ) : (
                          projects.map((project) => (
                            <li
                              key={project.id}
                              className="autocomplete-item"
                              onClick={() => handleProjectSelect(project)}
                            >
                              {project.name}
                            </li>
                          ))
                        )}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              <div
                className={`formRow mt-4 ${
                  errors.sub_locality_id || errors.furnish_type
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="localityInput"
                      placeholder=" "
                      value={localityInput}
                      onChange={handleLocalityInputChange}
                      className="textField"
                    />
                    <label htmlFor="localityInput" className="floating-label">
                      Locality (Optional)
                    </label>
                  </div>

                  {loadingLocalities && (
                    <div className="loading">Loading localities...</div>
                  )}

                  {showLocalityDropdown && localities.length > 0 && (
                    <ul className="autocomplete-dropdown">
                      {localities.map((locality) => (
                        <li
                          key={locality.id}
                          className="autocomplete-item"
                          onClick={() => handleLocalitySelect(locality)}
                        >
                          {locality.title}
                        </li>
                      ))}
                    </ul>
                  )}

                  {errors.sub_locality_id && (
                    <small className="text-danger">
                      {errors.sub_locality_id}
                    </small>
                  )}
                </div>
                {[
                  "apartment",
                  "independent_floor",
                  "independent_house",
                  "villa",
                ].includes(formData.propertyDetails.property_type) && (
                  <div className="w-50">
                    <CustomDropdown
                      formData={formData}
                      handleInputChange={handleInputChange}
                      index={"propertyDetails"}
                      field={"furnish_type"}
                      options={furnishType}
                      placeholder="Select Furnish Type"
                      required={"1"}
                      onSelect={(value) => console.log("furnish type:", value)}
                    />
                    {errors.furnish_type && (
                      <small className="text-danger">
                        {errors.furnish_type}
                      </small>
                    )}
                  </div>
                )}
              </div>
              {[
                "apartment",
                "independent_floor",
                "independent_house",
                "villa",
              ].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.bhk || errors.buildup_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"bhk"}
                        options={bhkOption}
                        placeholder="Select BHK"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.bhk && (
                        <small className="text-danger">{errors.bhk}</small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              {["plot", "agricultural_land"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.plot_area || errors.area_unit ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="plotArea"
                        placeholder=" "
                        value={formData.propertyDetails.plot_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "plot_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="plotArea" className="floating-label">
                        Plot Area <span className="required_field">*</span>
                      </label>
                      {errors.plot_area && (
                        <small className="text-danger">
                          {errors.plot_area}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"area_unit"}
                        options={areaUnitOption}
                        placeholder="Select Area Unit"
                        required={"1"}
                        onSelect={(value) => console.log("area unit:", value)}
                      />
                      {errors.area_unit && (
                        <small className="text-danger">
                          {errors.area_unit}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}
              {["plot", "agricultural_land"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.length || errors.width ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="length"
                        placeholder=" "
                        value={formData.propertyDetails.length || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "length",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="length" className="floating-label">
                        Length <span className="required_field">*</span>
                      </label>
                      {errors.length && (
                        <small className="text-danger">{errors.length}</small>
                      )}
                    </div>

                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="width"
                        placeholder=" "
                        value={formData.propertyDetails.width || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "width",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="width" className="floating-label">
                        Width <span className="required_field">*</span>
                      </label>
                      {errors.width && (
                        <small className="text-danger">{errors.width}</small>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
              <div className="cb">
                <input
                  type="checkbox"
                  checked={formData.propertyDetails.share_agent || false} // Ensure it's boolean
                  onChange={(e) =>
                    handleInputChange(
                      "propertyDetails",
                      "share_agent",
                      e.target.checked
                    )
                  }
                ></input>
                <span className="cb">
                  Share listing information with agents
                </span>
                {errors.share_agent && (
                  <small className="text-danger">{errors.share_agent}</small>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>

            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div
                className={`formRow mt-4 ${
                  errors.pricing || errors.construction_status ? "mb-5" : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <input
                    type="number"
                    id="pricing"
                    placeholder=" "
                    value={formData.propertyPrice.pricing || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyPrice",
                        "pricing",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pricing" className="floating-label">
                    Cost <span className="required_field">*</span>
                  </label>
                  {errors.pricing && (
                    <small className="text-danger">{errors.pricing}</small>
                  )}
                </div>
                <div className=" w-50 ">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"construction_status"}
                    options={constructionOption}
                    placeholder="Select Construction Status"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("construction status:", value)
                    }
                  />
                  {errors.construction_status && (
                    <small className="text-danger">
                      {errors.construction_status}
                    </small>
                  )}
                </div>
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.possession_date ? "mb-5" : "mb-3"
                }`}
              >
                {["under_construction"].includes(
                  formData.propertyDetails.construction_status
                ) && (
                  <>
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="propertyAge"
                        placeholder=" "
                        className="textField"
                        value={formData.propertyDetails.possession_date || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "possession_date",
                            e.target.value
                          )
                        }
                      />
                      <label htmlFor="propertyAge" className="floating-label">
                        Possession Date
                      </label>
                      {errors.possession_date && (
                        <small className="text-danger">
                          {errors.possession_date}
                        </small>
                      )}
                    </div>
                  </>
                )}
              </div>

              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
  // Input field for role (Builder/Agent) in Residential Rent category
  else if (
    selfType === 6 &&
    propertyType === "residential" &&
    propertyService === "rent"
  ) {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.property_type || errors.projectInput ? "mb-4" : "mb-4"
                }`}
              >
                <div className=" w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_type"}
                    options={rentPropertyType}
                    placeholder="Select Property Type"
                    required={"1"}
                    onSelect={(value) => console.log("property type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
                <div className="input-container w-50">
                  <div className="autocomplete-container">
                    {/* Project Dropdown */}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="buildingInput"
                        placeholder=" "
                        // value={formData.propertyDetails.building || ''}
                        value={projectInput}
                        // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                        onChange={handleProjectInputChange}
                        className="textField"
                      />
                      <label htmlFor="buildingInput" className="floating-label">
                        Building/Project/Society (Optional)
                      </label>
                    </div>

                    {loadingProjects && (
                      <div className="loading">Loading projects...</div>
                    )}

                    {showProjectDropdown && projectInput?.length >= 1 && (
                      <ul className="autocomplete-dropdown">
                        {projects.length === 0 ? ( // ✅ Only check for empty array
                          <li className="autocomplete-item no-results">
                            No results found
                            <button
                              className="add-new-btn"
                              // onClick={() => handleAddProjectSelect(projectInput)}
                              onClick={() =>
                                window.open("/addProject", "_blank")
                              }
                            >
                              + Add New
                            </button>
                          </li>
                        ) : (
                          projects.map((project) => (
                            <li
                              key={project.id}
                              className="autocomplete-item"
                              onClick={() => handleProjectSelect(project)}
                            >
                              {project.name}
                            </li>
                          ))
                        )}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              <div
                className={`formRow mt-4 ${
                  errors.sub_locality_id || errors.furnish_type
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="localityInput"
                      placeholder=" "
                      value={localityInput}
                      onChange={handleLocalityInputChange}
                      className="textField"
                    />
                    <label htmlFor="localityInput" className="floating-label">
                      Locality (Optional)
                    </label>
                  </div>

                  {loadingLocalities && (
                    <div className="loading">Loading localities...</div>
                  )}

                  {showLocalityDropdown && localities.length > 0 && (
                    <ul className="autocomplete-dropdown">
                      {localities.map((locality) => (
                        <li
                          key={locality.id}
                          className="autocomplete-item"
                          onClick={() => handleLocalitySelect(locality)}
                        >
                          {locality.title}
                        </li>
                      ))}
                    </ul>
                  )}

                  {errors.sub_locality_id && (
                    <small className="text-danger">
                      {errors.sub_locality_id}
                    </small>
                  )}
                </div>
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"furnish_type"}
                    options={furnishType}
                    placeholder="Select Furnish Type"
                    required={"1"}
                    onSelect={(value) => console.log("furnish type:", value)}
                  />
                  {errors.furnish_type && (
                    <small className="text-danger">{errors.furnish_type}</small>
                  )}
                </div>
              </div>
              {[
                "apartment",
                "independent_floor",
                "independent_house",
                "villa",
              ].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.bhk || errors.buildup_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"bhk"}
                        options={bhkOption}
                        placeholder="Select BHK"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.bhk && (
                        <small className="text-danger">{errors.bhk}</small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.lock_period || errors.lock_period_amount
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"lock_period"}
                        options={lockPeriodOption}
                        placeholder="Lock in Period"
                        onSelect={(value) => console.log("lock period:", value)}
                      />
                      {errors.lock_period && (
                        <small className="text-danger">
                          {errors.lock_period}
                        </small>
                      )}
                    </div>
                    {["custom"].includes(
                      formData.propertyDetails.lock_period
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="lock_period_amount"
                            placeholder=" "
                            value={
                              formData.propertyDetails.lock_period_amount || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "lock_period_amount",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="lock_period_amount"
                            className="floating-label"
                          >
                            Lock Period (in Rupees){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.lock_period_amount && (
                            <small className="text-danger">
                              {errors.lock_period_amount}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.brokerage_charge || errors.brokerage_amount
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"brokerage_charge"}
                        options={brokerageOption}
                        placeholder="Do you charge brokerage"
                        onSelect={(value) => console.log("brokerage:", value)}
                      />
                      {errors.brokerage_charge && (
                        <small className="text-danger">
                          {errors.brokerage_charge}
                        </small>
                      )}
                    </div>
                    {["custom"].includes(
                      formData.propertyDetails.brokerage_charge
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="brokerage_amount"
                            placeholder=" "
                            value={
                              formData.propertyDetails.brokerage_amount || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "brokerage_amount",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="brokerage_amount"
                            className="floating-label"
                          >
                            Brokerag (in Rupees){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.brokerage_amount && (
                            <small className="text-danger">
                              {errors.brokerage_amount}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
              <div className="cb">
                <input
                  type="checkbox"
                  checked={formData.propertyDetails.share_agent || false} // Ensure it's boolean
                  onChange={(e) =>
                    handleInputChange(
                      "propertyDetails",
                      "share_agent",
                      e.target.checked
                    )
                  }
                ></input>
                <span className="cb">
                  Share listing information with agents
                </span>
                {errors.share_agent && (
                  <small className="text-danger">{errors.share_agent}</small>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div
                className={`formRow mt-4 ${
                  errors.pricing || errors.available_from ? "mb-5" : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <input
                    type="number"
                    id="pricing"
                    placeholder=" "
                    value={formData.propertyPrice.pricing || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyPrice",
                        "pricing",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pricing" className="floating-label">
                    Monthly Rent <span className="required_field">*</span>
                  </label>
                  {errors.pricing && (
                    <small className="text-danger">{errors.pricing}</small>
                  )}
                </div>

                <div className="input-container w-50">
                  <input
                    type="date"
                    id="available_from"
                    placeholder=" "
                    value={formData.propertyDetails.available_from || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyDetails",
                        "available_from",
                        e.target.value
                      )
                    }
                    className="textField"
                  />
                  <label htmlFor="available_from" className="floating-label">
                    Available From <span className="required_field">*</span>
                  </label>
                  {errors.available_from && (
                    <small className="text-danger">
                      {errors.available_from}
                    </small>
                  )}
                </div>

                {/* <div className='input-container d-grid w-50'>
                  <input type="date" placeholder="Available From" value={formData.propertyPrice.availableForm || ''} onChange={(e) => handleInputChange('propertyPrice', 'availableForm', e.target.value)} className='textField' />
                  {errors.availableForm && <small className="text-danger">{errors.availableForm}</small>}
                </div> */}
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.security_deposit_month ||
                  errors.security_deposit_amount
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyPrice"}
                    field={"security_deposit_month"}
                    options={securityDepositOption}
                    placeholder="Select Security Deposit"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("security deposit:", value)
                    }
                  />
                  {errors.security_deposit_month && (
                    <small className="text-danger">
                      {errors.security_deposit_month}
                    </small>
                  )}
                </div>
                {["custom"].includes(
                  formData.propertyPrice.security_deposit_month
                ) && (
                  <>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="security_deposit_amount"
                        placeholder=" "
                        value={
                          formData.propertyPrice.security_deposit_amount || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "propertyPrice",
                            "security_deposit_amount",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="security_deposit_amount"
                        className="floating-label"
                      >
                        Security Deposit Amount{" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.security_deposit_amount && (
                        <small className="text-danger">
                          {errors.security_deposit_amount}
                        </small>
                      )}
                    </div>

                    {/* <div className='input-container d-grid w-50'>
                      <input type="text" placeholder="Security Deposit Amount" value={formData.propertyPrice.security_amount || ''} onChange={(e) => handleInputChange('propertyPrice', 'security_amount', e.target.value)} className='textField' />
                      {errors.security_amount && <small className="text-danger">{errors.security_amount}</small>}
                    </div> */}
                  </>
                )}
              </div>
              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
  // Input field for role (Buy/Owner) in Residential Rent category
  else if (
    selfType === 5 &&
    propertyType === "residential" &&
    propertyService === "rent"
  ) {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.property_type || errors.projectInput ? "mb-4" : "mb-4"
                }`}
              >
                <div className=" w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_type"}
                    options={rentPropertyType}
                    placeholder="Select Property Type"
                    required={"1"}
                    onSelect={(value) => console.log("property type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
                <div className="input-container w-50">
                  <div className="autocomplete-container">
                    {/* Project Dropdown */}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="buildingInput"
                        placeholder=" "
                        // value={formData.propertyDetails.building || ''}
                        value={projectInput}
                        // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                        onChange={handleProjectInputChange}
                        className="textField"
                      />
                      <label htmlFor="buildingInput" className="floating-label">
                        Building/Project/Society (Optional)
                      </label>
                    </div>

                    {loadingProjects && (
                      <div className="loading">Loading projects...</div>
                    )}

                    {showProjectDropdown && projectInput?.length >= 1 && (
                      <ul className="autocomplete-dropdown">
                        {projects.length === 0 ? ( // ✅ Only check for empty array
                          <li className="autocomplete-item no-results">
                            No results found
                            {/* <button
                            className="add-new-btn"
                            onClick={() => handleAddProjectSelect(projectInput)}
                          >
                            + Add New
                          </button> */}
                          </li>
                        ) : (
                          projects.map((project) => (
                            <li
                              key={project.id}
                              className="autocomplete-item"
                              onClick={() => handleProjectSelect(project)}
                            >
                              {project.name}
                            </li>
                          ))
                        )}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              <div
                className={`formRow mt-4 ${
                  errors.sub_locality_id || errors.furnish_type
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="localityInput"
                      placeholder=" "
                      value={localityInput}
                      onChange={handleLocalityInputChange}
                      className="textField"
                    />
                    <label htmlFor="localityInput" className="floating-label">
                      Locality (Optional)
                    </label>
                  </div>

                  {loadingLocalities && (
                    <div className="loading">Loading localities...</div>
                  )}

                  {showLocalityDropdown && localities.length > 0 && (
                    <ul className="autocomplete-dropdown">
                      {localities.map((locality) => (
                        <li
                          key={locality.id}
                          className="autocomplete-item"
                          onClick={() => handleLocalitySelect(locality)}
                        >
                          {locality.title}
                        </li>
                      ))}
                    </ul>
                  )}

                  {errors.sub_locality_id && (
                    <small className="text-danger">
                      {errors.sub_locality_id}
                    </small>
                  )}
                </div>
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"furnish_type"}
                    options={furnishType}
                    placeholder="Select Furnish Type"
                    required={"1"}
                    onSelect={(value) => console.log("furnish type:", value)}
                  />
                  {errors.furnish_type && (
                    <small className="text-danger">{errors.furnish_type}</small>
                  )}
                </div>
              </div>
              {[
                "apartment",
                "independent_floor",
                "independent_house",
                "villa",
              ].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.bhk || errors.buildup_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"bhk"}
                        options={bhkOption}
                        placeholder="Select BHK"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.bhk && (
                        <small className="text-danger">{errors.bhk}</small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
              <div className="cb">
                <input
                  type="checkbox"
                  checked={formData.propertyDetails.share_agent || false} // Ensure it's boolean
                  onChange={(e) =>
                    handleInputChange(
                      "propertyDetails",
                      "share_agent",
                      e.target.checked
                    )
                  }
                ></input>
                <span className="cb">
                  Share listing information with agents
                </span>
                {errors.share_agent && (
                  <small className="text-danger">{errors.share_agent}</small>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div
                className={`formRow mt-4 ${
                  errors.pricing || errors.available_from ? "mb-5" : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <input
                    type="number"
                    id="pricing"
                    placeholder=" "
                    value={formData.propertyPrice.pricing || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyPrice",
                        "pricing",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pricing" className="floating-label">
                    Monthly Rent <span className="required_field">*</span>
                  </label>
                  {errors.pricing && (
                    <small className="text-danger">{errors.pricing}</small>
                  )}
                </div>

                <div className="input-container w-50">
                  <input
                    type="date"
                    id="available_from"
                    placeholder=" "
                    value={formData.propertyDetails.available_from || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyDetails",
                        "available_from",
                        e.target.value
                      )
                    }
                    className="textField"
                  />
                  <label htmlFor="available_from" className="floating-label">
                    Available From <span className="required_field">*</span>
                  </label>
                  {errors.available_from && (
                    <small className="text-danger">
                      {errors.available_from}
                    </small>
                  )}
                </div>

                {/* <div className='input-container d-grid w-50'>
                  <input type="date" placeholder="Available From" value={formData.propertyPrice.availableForm || ''} onChange={(e) => handleInputChange('propertyPrice', 'availableForm', e.target.value)} className='textField' />
                  {errors.availableForm && <small className="text-danger">{errors.availableForm}</small>}
                </div> */}
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.security_deposit_month ||
                  errors.security_deposit_amount
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyPrice"}
                    field={"security_deposit_month"}
                    options={securityDepositOption}
                    placeholder="Select Security Deposit"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("security deposit:", value)
                    }
                  />
                  {errors.security_deposit_month && (
                    <small className="text-danger">
                      {errors.security_deposit_month}
                    </small>
                  )}
                </div>
                {["custom"].includes(
                  formData.propertyPrice.security_deposit_month
                ) && (
                  <>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="security_deposit_amount"
                        placeholder=" "
                        value={
                          formData.propertyPrice.security_deposit_amount || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "propertyPrice",
                            "security_deposit_amount",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="security_deposit_amount"
                        className="floating-label"
                      >
                        Security Deposit Amount{" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.security_deposit_amount && (
                        <small className="text-danger">
                          {errors.security_deposit_amount}
                        </small>
                      )}
                    </div>

                    {/* <div className='input-container d-grid w-50'>
                      <input type="text" placeholder="Security Deposit Amount" value={formData.propertyPrice.security_amount || ''} onChange={(e) => handleInputChange('propertyPrice', 'security_amount', e.target.value)} className='textField' />
                      {errors.security_amount && <small className="text-danger">{errors.security_amount}</small>}
                    </div> */}
                  </>
                )}
              </div>
              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
  // Input field in Residential Living category
  else if (propertyType === "residential" && propertyService === "living") {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.sub_locality_id || errors.projectInput
                    ? "mb-4"
                    : "mb-4"
                }`}
              >
                <div className="input-container w-50">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="localityInput"
                      placeholder=" "
                      value={localityInput}
                      onChange={handleLocalityInputChange}
                      className="textField"
                    />
                    <label htmlFor="localityInput" className="floating-label">
                      Locality (Optional)
                    </label>
                  </div>

                  {loadingLocalities && (
                    <div className="loading">Loading localities...</div>
                  )}

                  {showLocalityDropdown && localities.length > 0 && (
                    <ul className="autocomplete-dropdown">
                      {localities.map((locality) => (
                        <li
                          key={locality.id}
                          className="autocomplete-item"
                          onClick={() => handleLocalitySelect(locality)}
                        >
                          {locality.title}
                        </li>
                      ))}
                    </ul>
                  )}

                  {errors.sub_locality_id && (
                    <small className="text-danger">
                      {errors.sub_locality_id}
                    </small>
                  )}
                </div>
                <div className="input-container w-50">
                  <div className="autocomplete-container">
                    {/* Project Dropdown */}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="buildingInput"
                        placeholder=" "
                        // value={formData.propertyDetails.building || ''}
                        value={projectInput}
                        // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                        onChange={handleProjectInputChange}
                        className="textField"
                      />
                      <label htmlFor="buildingInput" className="floating-label">
                        Building/Project/Society (Optional)
                      </label>
                    </div>

                    {loadingProjects && (
                      <div className="loading">Loading projects...</div>
                    )}

                    {showProjectDropdown && projects.length > 0 && (
                      <ul className="autocomplete-dropdown">
                        {projects.map((project) => (
                          <li
                            key={project.id}
                            className="autocomplete-item"
                            onClick={() => handleProjectSelect(project)}
                          >
                            {project.name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              <div
                className={`formRow  mt-4 ${
                  errors.pg_name || errors.pg_total_beds ? "mb-5" : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <input
                    type="text"
                    id="pg_name"
                    placeholder=" "
                    value={formData.propertyDetails.pg_name || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyDetails",
                        "pg_name",
                        e.target.value
                      )
                    }
                    className="textField"
                  />
                  <label htmlFor="pg_name" className="floating-label">
                    PG Name <span className="required_field">*</span>
                  </label>
                  {errors.pg_name && (
                    <small className="text-danger">{errors.pg_name}</small>
                  )}
                </div>
                <div className="input-container w-50">
                  <input
                    type="text"
                    id="pg_total_beds"
                    placeholder=" "
                    value={formData.propertyDetails.pg_total_beds || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyDetails",
                        "pg_total_beds",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pg_total_beds" className="floating-label">
                    Total Bed <span className="required_field">*</span>
                  </label>
                  {errors.pg_total_beds && (
                    <small className="text-danger">
                      {errors.pg_total_beds}
                    </small>
                  )}
                </div>
              </div>

              <div
                className={`formRow  mt-4 ${
                  errors.pg_for || errors.pg_suitable_for ? "mb-5" : "mb-3"
                }`}
              >
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"pg_for"}
                    multiple={true}
                    options={pgOption}
                    placeholder="PG is for"
                    required={"1"}
                    onSelect={(value) => console.log("pg is:", value)}
                  />
                  {errors.pg_for && (
                    <small className="text-danger">{errors.pg_for}</small>
                  )}
                </div>
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"pg_suitable_for"}
                    multiple={true}
                    options={suitedOption}
                    placeholder="Best suited for"
                    required={"1"}
                    onSelect={(value) => console.log("suited for:", value)}
                  />
                  {errors.pg_suitable_for && (
                    <small className="text-danger">
                      {errors.pg_suitable_for}
                    </small>
                  )}
                </div>
              </div>

              <div
                className={`formRow  mt-4 ${
                  errors.pg_meals_available || errors.pg_meals_offering
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"pg_meals_available"}
                    options={mealAvailableOption}
                    placeholder="Meals Available"
                    required={"1"}
                    onSelect={(value) => console.log("meal available:", value)}
                  />
                  {errors.pg_meals_available && (
                    <small className="text-danger">
                      {errors.pg_meals_available}
                    </small>
                  )}
                </div>
                {["yes"].includes(
                  formData.propertyDetails.pg_meals_available
                ) && (
                  <>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"pg_meals_offering"}
                        multiple={true}
                        options={mealOfferingOption}
                        placeholder="Meal Offerings"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("meal offering:", value)
                        }
                      />
                      {errors.pg_meals_offering && (
                        <small className="text-danger">
                          {errors.pg_meals_offering}
                        </small>
                      )}
                    </div>
                  </>
                )}
              </div>

              <div
                className={`formRow  mt-4 ${
                  errors.pg_notice_period || errors.pg_lock_in ? "mb-5" : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <input
                    type="text"
                    id="pg_notice_period"
                    placeholder=" "
                    value={formData.propertyDetails.pg_notice_period || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyDetails",
                        "pg_notice_period",
                        e.target.value
                      )
                    }
                    className="textField"
                  />
                  <label htmlFor="pg_notice_period" className="floating-label">
                    Notice Period (Days){" "}
                    <span className="required_field">*</span>
                  </label>
                  {errors.pg_notice_period && (
                    <small className="text-danger">
                      {errors.pg_notice_period}
                    </small>
                  )}
                </div>
                <div className="input-container w-50">
                  <input
                    type="text"
                    id="pg_lock_in"
                    placeholder=" "
                    value={formData.propertyDetails.pg_lock_in || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyDetails",
                        "pg_lock_in",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pg_lock_in" className="floating-label">
                    Lock in Period (Days){" "}
                    <span className="required_field">*</span>
                  </label>
                  {errors.pg_lock_in && (
                    <small className="text-danger">{errors.pg_lock_in}</small>
                  )}
                </div>
              </div>

              <div
                className={`formRow  mt-4 ${
                  errors.pg_common_area || errors.pg_meals_speciality
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"pg_meals_speciality"}
                    options={mealSpecialityOption}
                    placeholder="Meal Speciality"
                    onSelect={(value) => console.log("meal offering:", value)}
                  />
                  {errors.pg_meals_speciality && (
                    <small className="text-danger">
                      {errors.pg_meals_speciality}
                    </small>
                  )}
                </div>
                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"pg_common_area"}
                    multiple={true}
                    options={commonAreaOption}
                    placeholder="Common Areas"
                    required={"1"}
                    onSelect={(value) => console.log("common area:", value)}
                  />
                  {errors.pg_common_area && (
                    <small className="text-danger">
                      {errors.pg_common_area}
                    </small>
                  )}
                </div>
              </div>

              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
              <div className="cb">
                <input
                  type="checkbox"
                  checked={formData.propertyDetails.share_agent || false} // Ensure it's boolean
                  onChange={(e) =>
                    handleInputChange(
                      "propertyDetails",
                      "share_agent",
                      e.target.checked
                    )
                  }
                ></input>
                <span className="cb">
                  Share listing information with agents
                </span>
                {errors.share_agent && (
                  <small className="text-danger">{errors.share_agent}</small>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div className="space-y-4">
                {rooms.map((room) => (
                  <div
                    key={room.id}
                    className="border mt-2 p-4 rounded-lg shadow-sm relative"
                  >
                    <div className="d-flex justify-content-between items-center mb-2">
                      <h3 className="room_title">Room {room.id}</h3>
                      <button
                        className="room_detail_delete"
                        variant="destructive"
                        size="sm"
                        onClick={() => removeRoom(room.id)}
                      >
                        Delete
                      </button>
                    </div>

                    <div
                      className={`formRow  mt-4 ${
                        errors.pg_room_type || errors.pricing ? "mb-4" : "mb-4"
                      }`}
                    >
                      <div className="w-50">
                        <CustomDropdown
                          formData={formData}
                          handleInputChange={handleInputChange}
                          index={"roomDetail"}
                          i={room.id}
                          field={`pg_room_type`}
                          options={roomTypeOption}
                          placeholder="Room Type"
                          required={"1"}
                          onSelect={(value) => console.log("room type:", value)}
                        />
                        {errors[`roomDetail.${room.id}.pg_room_type`] && (
                          <small className="text-danger">
                            {errors[`roomDetail.${room.id}.pg_room_type`]}
                          </small>
                        )}
                      </div>
                      <div className="input-container w-50">
                        <input
                          type="text"
                          id="pricing"
                          placeholder=" "
                          value={formData.roomDetail[room.id]?.pricing || ""}
                          onChange={(e) =>
                            handleInputChange(
                              "roomDetail",
                              `pricing`,
                              e.target.value,
                              room.id
                            )
                          }
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ))
                          }
                          className="textField"
                        />
                        <label htmlFor="pricing" className="floating-label">
                          Rent <span className="required_field">*</span>
                        </label>
                        {errors[`roomDetail.${room.id}.pricing`] && (
                          <small className="text-danger">
                            {errors[`roomDetail.${room.id}.pricing`]}
                          </small>
                        )}
                      </div>
                    </div>
                    <div
                      className={`formRow  mt-4 ${
                        errors.roomDetail?.[room.id]?.security_deposit_amount
                          ? "mb-4"
                          : "mb-4"
                      }`}
                    >
                      <div className="input-container w-50">
                        <input
                          type="text"
                          placeholder=" "
                          value={
                            formData?.roomDetail[room.id]
                              ?.security_deposit_amount || ""
                          }
                          onChange={(e) =>
                            handleInputChange(
                              "roomDetail",
                              `security_deposit_amount`,
                              e.target.value,
                              room.id
                            )
                          }
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ))
                          }
                          className="textField"
                        />
                        <label
                          htmlFor="security_deposit_amount"
                          className="floating-label"
                        >
                          Security Amount{" "}
                          <span className="required_field">*</span>
                        </label>
                        {errors[
                          `roomDetail.${room.id}.security_deposit_amount`
                        ] && (
                          <small className="text-danger">
                            {
                              errors[
                                `roomDetail.${room.id}.security_deposit_amount`
                              ]
                            }
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                <button
                  variant="default"
                  onClick={addRoom}
                  className="room_add mt-4"
                >
                  Add Another Room
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
  // Input field for role (Builder/Agent) in Commercial Rent category
  else if (
    selfType === 6 &&
    propertyType === "commercial" &&
    propertyService === "rent"
  ) {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.property_type ? "mb-4" : "mb-4"
                }`}
              >
                <div className=" w-100">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_type"}
                    options={commercialPropertyType}
                    placeholder="Select Property Type"
                    required={"1"}
                    onSelect={(value) => console.log("property type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
              </div>

              <div
                className={`formRow mt-4 ${
                  errors.projectInput || errors.sub_locality_id
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <div className="autocomplete-container">
                    {/* Project Dropdown */}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="buildingInput"
                        placeholder=" "
                        // value={formData.propertyDetails.building || ''}
                        value={projectInput}
                        // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                        onChange={handleProjectInputChange}
                        className="textField"
                      />
                      <label htmlFor="buildingInput" className="floating-label">
                        Building/Project/Society (Optional)
                      </label>
                    </div>

                    {loadingProjects && (
                      <div className="loading">Loading projects...</div>
                    )}

                    {showProjectDropdown && projectInput?.length >= 1 && (
                      <ul className="autocomplete-dropdown">
                        {projects.length === 0 ? ( // ✅ Only check for empty array
                          <li className="autocomplete-item no-results">
                            No results found
                            <button
                              className="add-new-btn"
                              // onClick={() => handleAddProjectSelect(projectInput)}
                              onClick={() =>
                                window.open("/addProject", "_blank")
                              }
                            >
                              + Add New
                            </button>
                          </li>
                        ) : (
                          projects.map((project) => (
                            <li
                              key={project.id}
                              className="autocomplete-item"
                              onClick={() => handleProjectSelect(project)}
                            >
                              {project.name}
                            </li>
                          ))
                        )}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="input-container w-50">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="localityInput"
                      placeholder=" "
                      value={localityInput}
                      onChange={handleLocalityInputChange}
                      className="textField"
                    />
                    <label htmlFor="localityInput" className="floating-label">
                      Locality (Optional)
                    </label>
                  </div>

                  {loadingLocalities && (
                    <div className="loading">Loading localities...</div>
                  )}

                  {showLocalityDropdown && localities.length > 0 && (
                    <ul className="autocomplete-dropdown">
                      {localities.map((locality) => (
                        <li
                          key={locality.id}
                          className="autocomplete-item"
                          onClick={() => handleLocalitySelect(locality)}
                        >
                          {locality.title}
                        </li>
                      ))}
                    </ul>
                  )}

                  {errors.sub_locality_id && (
                    <small className="text-danger">
                      {errors.sub_locality_id}
                    </small>
                  )}
                </div>
              </div>

              {["office"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>

                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        min={new Date().toISOString().split("T")[0]} // Disables past dates
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.property_condition
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHubOption}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"property_condition"}
                        options={propertyConditionOption}
                        placeholder="Select Property Condition"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.property_condition && (
                        <small className="text-danger">
                          {errors.property_condition}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.carpet_area || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>

                    {["ready_use"].includes(
                      formData.propertyDetails.property_condition
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="carpet_area"
                            placeholder=" "
                            value={formData.propertyDetails.carpet_area || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "carpet_area",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="carpet_area"
                            className="floating-label"
                          >
                            Carpet Area(in sq.ft.){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.carpet_area && (
                            <small className="text-danger">
                              {errors.carpet_area}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  {["ready_use"].includes(
                    formData.propertyDetails.property_condition
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.number_of_seats_input ||
                          errors.number_of_cabins_input
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="number_of_seats_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails.number_of_seats_input ||
                              ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_seats_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_seats_input"
                            className="floating-label"
                          >
                            Number of Seat
                          </label>
                          {errors.number_of_seats_input && (
                            <small className="text-danger">
                              {errors.number_of_seats_input}
                            </small>
                          )}
                        </div>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="number_of_cabins_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails.number_of_cabins_input ||
                              ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_cabins_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_cabins_input"
                            className="floating-label"
                          >
                            Number of Cabins
                          </label>
                          {errors.number_of_cabins_input && (
                            <small className="text-danger">
                              {errors.number_of_cabins_input}
                            </small>
                          )}
                        </div>
                      </div>
                      <div
                        className={`formRow mt-4 ${
                          errors.number_of_meeting_rooms_input ||
                          errors.conference_room
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="input-container d-grid w-50">
                          <input
                            type="text"
                            id="number_of_meeting_rooms_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails
                                .number_of_meeting_rooms_input || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_meeting_rooms_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_meeting_rooms_input"
                            className="floating-label"
                          >
                            Number of Meeting Room
                          </label>
                          {errors.number_of_meeting_rooms_input && (
                            <small className="text-danger">
                              {errors.number_of_meeting_rooms_input}
                            </small>
                          )}
                        </div>
                        <div className="input-container d-grid w-50">
                          <input
                            type="text"
                            id="conference_room"
                            placeholder=" "
                            value={
                              formData.propertyDetails.conference_room || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "conference_room",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="conference_room"
                            className="floating-label"
                          >
                            Conference Room
                          </label>
                          {errors.conference_room && (
                            <small className="text-danger">
                              {errors.conference_room}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["bare_shell"].includes(
                    formData.propertyDetails.property_condition
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.construction_status || errors.flooring
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="w-50">
                          <CustomDropdown
                            formData={formData}
                            handleInputChange={handleInputChange}
                            index={"propertyDetails"}
                            field={"construction_status"}
                            options={constructionStatusOption}
                            placeholder="Select Construction Status"
                            required={"1"}
                            onSelect={(value) => console.log("BHK:", value)}
                          />
                          {errors.construction_status && (
                            <small className="text-danger">
                              {errors.construction_status}
                            </small>
                          )}
                        </div>
                        <div className="w-50">
                          <CustomDropdown
                            formData={formData}
                            handleInputChange={handleInputChange}
                            index={"propertyDetails"}
                            field={"flooring"}
                            options={flooringOption}
                            placeholder="Select Flooring"
                            onSelect={(value) =>
                              console.log("flooring:", value)
                            }
                          />
                          {errors.flooring && (
                            <small className="text-danger">
                              {errors.flooring}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow mt-4 ${
                      errors.other_location_hub || errors.property_age
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    {["ready_to_use"].includes(
                      formData.propertyDetails.possession_status
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["retailshop", "showroom"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className=" w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.ownership || errors.carpet_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="d-grid w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.suitable_for || errors.lock_period
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="d-grid w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"suitable_for"}
                        options={suitableOption}
                        placeholder="Select Suitable For"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("suitable for:", value)
                        }
                      />
                      {errors.suitable_for && (
                        <small className="text-danger">
                          {errors.suitable_for}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="lock_period"
                        placeholder=" "
                        value={formData.propertyDetails.lock_period || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "lock_period",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="lock_period" className="floating-label">
                        Lock in Period
                      </label>
                      {errors.lock_period && (
                        <small className="text-danger">
                          {errors.lock_period}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.property_age || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    {["ready_to_use"].includes(
                      formData.propertyDetails.possession_status
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["warehouse"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                  </div>

                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="d-grid w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="d-grid w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div
                    className={`formRow mt-4 ${
                      errors.buildup_area || errors.carpet_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>

                  <div
                    className={`formRow mt-4 ${
                      errors.property_age ? "mb-5" : "mb-3"
                    }`}
                  >
                    {["ready_to_use"].includes(
                      formData.propertyDetails.possession_status
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["plot"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.available_from || errors.plot_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="plot_area"
                        placeholder=" "
                        value={formData.propertyDetails.plot_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "plot_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="plot_area" className="floating-label">
                        Plot Area <span className="required_field">*</span>
                      </label>
                      {errors.plot_area && (
                        <small className="text-danger">
                          {errors.plot_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              {["other"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                  </div>

                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.property_age ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.buildup_area || errors.carpet_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.property_name ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="property_name"
                        placeholder=" "
                        value={formData.propertyDetails.property_name || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "property_name",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label htmlFor="property_name" className="floating-label">
                        Property Name <span className="required_field">*</span>
                      </label>
                      {errors.property_name && (
                        <small className="text-danger">
                          {errors.property_name}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div
                className={`formRow mt-4 ${
                  errors.pricing || errors.security_deposit_month
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container d-grid w-50">
                  <input
                    type="number"
                    id="pricing"
                    placeholder=" "
                    value={formData.propertyPrice.pricing || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyPrice",
                        "pricing",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pricing" className="floating-label">
                    Price <span className="required_field">*</span>
                  </label>
                  {errors.pricing && (
                    <small className="text-danger">{errors.pricing}</small>
                  )}
                </div>

                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyPrice"}
                    field={"security_deposit_month"}
                    options={securityDepositOption}
                    placeholder="Select Security Deposit"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("security deposit:", value)
                    }
                  />
                  {errors.security_deposit_month && (
                    <small className="text-danger">
                      {errors.security_deposit_month}
                    </small>
                  )}
                </div>
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.security_deposit_amount ? "mb-5" : "mb-3"
                }`}
              >
                {["custom"].includes(
                  formData.propertyPrice.security_deposit_month
                ) && (
                  <>
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="security_deposit"
                        placeholder=""
                        value={
                          formData.propertyPrice.security_deposit_amount || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "propertyPrice",
                            "security_deposit_amount",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="security_deposit"
                        className="floating-label"
                      >
                        Security Deposit Amount{" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.security_deposit_amount && (
                        <small className="text-danger">
                          {errors.security_deposit_amount}
                        </small>
                      )}
                    </div>
                  </>
                )}
              </div>
              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
  // Input field for role (Buy/Owner) in Commercial Rent category
  else if (
    selfType === 5 &&
    propertyType === "commercial" &&
    propertyService === "rent"
  ) {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.property_type ? "mb-4" : "mb-4"
                }`}
              >
                <div className=" w-100">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_type"}
                    options={commercialPropertyType}
                    placeholder="Select Property Type"
                    required={"1"}
                    onSelect={(value) => console.log("property type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
              </div>

              <div
                className={`formRow mt-4 ${
                  errors.projectInput || errors.sub_locality_id
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <div className="autocomplete-container">
                    {/* Project Dropdown */}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        id="buildingInput"
                        placeholder=" "
                        // value={formData.propertyDetails.building || ''}
                        value={projectInput}
                        // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                        onChange={handleProjectInputChange}
                        className="textField"
                      />
                      <label htmlFor="buildingInput" className="floating-label">
                        Building/Project/Society (Optional)
                      </label>
                    </div>

                    {loadingProjects && (
                      <div className="loading">Loading projects...</div>
                    )}

                    {showProjectDropdown && projectInput?.length >= 1 && (
                      <ul className="autocomplete-dropdown">
                        {projects.length === 0 ? ( // ✅ Only check for empty array
                          <li className="autocomplete-item no-results">
                            No results found
                            {/* <button
                            className="add-new-btn"
                            onClick={() => handleAddProjectSelect(projectInput)}
                          >
                            + Add New
                          </button> */}
                          </li>
                        ) : (
                          projects.map((project) => (
                            <li
                              key={project.id}
                              className="autocomplete-item"
                              onClick={() => handleProjectSelect(project)}
                            >
                              {project.name}
                            </li>
                          ))
                        )}
                      </ul>
                    )}
                  </div>
                </div>
                <div className="input-container w-50">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      id="localityInput"
                      placeholder=" "
                      value={localityInput}
                      onChange={handleLocalityInputChange}
                      className="textField"
                    />
                    <label htmlFor="localityInput" className="floating-label">
                      Locality (Optional)
                    </label>
                  </div>

                  {loadingLocalities && (
                    <div className="loading">Loading localities...</div>
                  )}

                  {showLocalityDropdown && localities.length > 0 && (
                    <ul className="autocomplete-dropdown">
                      {localities.map((locality) => (
                        <li
                          key={locality.id}
                          className="autocomplete-item"
                          onClick={() => handleLocalitySelect(locality)}
                        >
                          {locality.title}
                        </li>
                      ))}
                    </ul>
                  )}

                  {errors.sub_locality_id && (
                    <small className="text-danger">
                      {errors.sub_locality_id}
                    </small>
                  )}
                </div>
              </div>

              {["office"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>

                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.property_condition
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHubOption}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"property_condition"}
                        options={propertyConditionOption}
                        placeholder="Select Property Condition"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.property_condition && (
                        <small className="text-danger">
                          {errors.property_condition}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.carpet_area || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>

                    {["ready_use"].includes(
                      formData.propertyDetails.property_condition
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="carpet_area"
                            placeholder=" "
                            value={formData.propertyDetails.carpet_area || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "carpet_area",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="carpet_area"
                            className="floating-label"
                          >
                            Carpet Area(in sq.ft.){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.carpet_area && (
                            <small className="text-danger">
                              {errors.carpet_area}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  {["ready_use"].includes(
                    formData.propertyDetails.property_condition
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.number_of_seats_input ||
                          errors.number_of_cabins_input
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="number_of_seats_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails.number_of_seats_input ||
                              ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_seats_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_seats_input"
                            className="floating-label"
                          >
                            Number of Seat
                          </label>
                          {errors.number_of_seats_input && (
                            <small className="text-danger">
                              {errors.number_of_seats_input}
                            </small>
                          )}
                        </div>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="number_of_cabins_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails.number_of_cabins_input ||
                              ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_cabins_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_cabins_input"
                            className="floating-label"
                          >
                            Number of Cabins
                          </label>
                          {errors.number_of_cabins_input && (
                            <small className="text-danger">
                              {errors.number_of_cabins_input}
                            </small>
                          )}
                        </div>
                      </div>
                      <div
                        className={`formRow mt-4 ${
                          errors.number_of_meeting_rooms_input ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container d-grid w-50">
                          <input
                            type="text"
                            id="number_of_meeting_rooms_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails
                                .number_of_meeting_rooms_input || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_meeting_rooms_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_meeting_rooms_input"
                            className="floating-label"
                          >
                            Number of Meeting Room
                          </label>
                          {errors.number_of_meeting_rooms_input && (
                            <small className="text-danger">
                              {errors.number_of_meeting_rooms_input}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow mt-4 ${
                      errors.construction_status ? "mb-5" : "mb-3"
                    }`}
                  >
                    {["bare_shell"].includes(
                      formData.propertyDetails.property_condition
                    ) && (
                      <>
                        <div className="w-50">
                          <CustomDropdown
                            formData={formData}
                            handleInputChange={handleInputChange}
                            index={"propertyDetails"}
                            field={"construction_status"}
                            options={constructionStatusOption}
                            placeholder="Select Construction Status"
                            required={"1"}
                            onSelect={(value) => console.log("BHK:", value)}
                          />
                          {errors.construction_status && (
                            <small className="text-danger">
                              {errors.construction_status}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.other_location_hub || errors.property_age
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    {["ready_to_use"].includes(
                      formData.propertyDetails.possession_status
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub)
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["retailshop", "showroom"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className=" w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.ownership || errors.carpet_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="d-grid w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) => console.log("BHK:", value)}
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.property_age || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    {["ready_to_use"].includes(
                      formData.propertyDetails.possession_status
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["warehouse"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                  </div>

                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="d-grid w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="d-grid w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  <div
                    className={`formRow mt-4 ${
                      errors.buildup_area || errors.carpet_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>

                  <div
                    className={`formRow mt-4 ${
                      errors.property_age ? "mb-5" : "mb-3"
                    }`}
                  >
                    {["ready_to_use"].includes(
                      formData.propertyDetails.possession_status
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["plot"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.available_from || errors.plot_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="plot_area"
                        placeholder=" "
                        value={formData.propertyDetails.plot_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "plot_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="plot_area" className="floating-label">
                        Plot Area <span className="required_field">*</span>
                      </label>
                      {errors.plot_area && (
                        <small className="text-danger">
                          {errors.plot_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              {["other"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="date"
                        id="available_from"
                        placeholder=" "
                        value={formData.propertyDetails.available_from || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "available_from",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="available_from"
                        className="floating-label"
                      >
                        Available From <span className="required_field">*</span>
                      </label>
                      {errors.available_from && (
                        <small className="text-danger">
                          {errors.available_from}
                        </small>
                      )}
                    </div>
                  </div>

                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.property_age ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.buildup_area || errors.carpet_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.property_name ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="property_name"
                        placeholder=" "
                        value={formData.propertyDetails.property_name || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "property_name",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label htmlFor="property_name" className="floating-label">
                        Property Name <span className="required_field">*</span>
                      </label>
                      {errors.property_name && (
                        <small className="text-danger">
                          {errors.property_name}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div
                className={`formRow mt-4 ${
                  errors.pricing || errors.security_deposit_month
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container d-grid w-50">
                  <input
                    type="number"
                    id="pricing"
                    placeholder=" "
                    value={formData.propertyPrice.pricing || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyPrice",
                        "pricing",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pricing" className="floating-label">
                    Price <span className="required_field">*</span>
                  </label>
                  {errors.pricing && (
                    <small className="text-danger">{errors.pricing}</small>
                  )}
                </div>

                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyPrice"}
                    field={"security_deposit_month"}
                    options={securityDepositOption}
                    placeholder="Select Security Deposit"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("security deposit:", value)
                    }
                  />
                  {errors.security_deposit_month && (
                    <small className="text-danger">
                      {errors.security_deposit_month}
                    </small>
                  )}
                </div>
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.security_deposit_amount ? "mb-5" : "mb-3"
                }`}
              >
                {["custom"].includes(
                  formData.propertyPrice.security_deposit_month
                ) && (
                  <>
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="security_deposit"
                        placeholder=""
                        value={
                          formData.propertyPrice.security_deposit_amount || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "propertyPrice",
                            "security_deposit_amount",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="security_deposit"
                        className="floating-label"
                      >
                        Security Deposit Amount{" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.security_deposit_amount && (
                        <small className="text-danger">
                          {errors.security_deposit_amount}
                        </small>
                      )}
                    </div>
                  </>
                )}
              </div>
              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
  // Input field for role (Builder/Agent) in Commercial Sell category
  else if (
    selfType === 6 &&
    propertyType === "commercial" &&
    propertyService === "sell"
  ) {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.property_type ? "mb-4" : "mb-4"
                }`}
              >
                <div className=" w-100">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_type"}
                    options={commercialPropertyType}
                    placeholder="Select Property Type"
                    required={"1"}
                    onSelect={(value) => console.log("property type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
              </div>
              {["office"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                <button
                                  className="add-new-btn"
                                  // onClick={() => handleAddProjectSelect(projectInput)}
                                  onClick={() =>
                                    window.open("/addProject", "_blank")
                                  }
                                >
                                  + Add New
                                </button>
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                  </div>
                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.property_age ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["under_construction"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.possession_date ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="date"
                            id="possession_date"
                            placeholder=" "
                            value={
                              formData.propertyDetails.possession_date || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "possession_date",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="possession_date"
                            className="floating-label"
                          >
                            Possession Date{" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.possession_date && (
                            <small className="text-danger">
                              {errors.possession_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHubOption}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.property_condition || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"property_condition"}
                        options={propertyConditionOption}
                        placeholder="Select Property Condition"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("property condition:", value)
                        }
                      />
                      {errors.property_condition && (
                        <small className="text-danger">
                          {errors.property_condition}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  {["bare_shell"].includes(
                    formData.propertyDetails.property_condition
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.construction_status || errors.flooring
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="w-50">
                          <CustomDropdown
                            formData={formData}
                            handleInputChange={handleInputChange}
                            index={"propertyDetails"}
                            field={"construction_status"}
                            options={constructionStatusOption}
                            placeholder="Select Construction Status"
                            required={"1"}
                            onSelect={(value) => console.log("BHK:", value)}
                          />
                          {errors.construction_status && (
                            <small className="text-danger">
                              {errors.construction_status}
                            </small>
                          )}
                        </div>
                        <div className="w-50">
                          <CustomDropdown
                            formData={formData}
                            handleInputChange={handleInputChange}
                            index={"propertyDetails"}
                            field={"flooring"}
                            options={flooringOption}
                            placeholder="Select Flooring"
                            onSelect={(value) =>
                              console.log("flooring:", value)
                            }
                          />
                          {errors.flooring && (
                            <small className="text-danger">
                              {errors.flooring}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {["ready_use"].includes(
                    formData.propertyDetails.property_condition
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.carpet_area ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="carpet_area"
                            placeholder=" "
                            value={formData.propertyDetails.carpet_area || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "carpet_area",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="carpet_area"
                            className="floating-label"
                          >
                            Carpet Area(in sq.ft.){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.carpet_area && (
                            <small className="text-danger">
                              {errors.carpet_area}
                            </small>
                          )}
                        </div>
                      </div>
                      <div
                        className={`formRow mt-4 ${
                          errors.number_of_seats_input ||
                          errors.number_of_cabins_input
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="number_of_seats_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails.number_of_seats_input ||
                              ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_seats_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_seats_input"
                            className="floating-label"
                          >
                            Number of Seat
                          </label>
                          {errors.number_of_seats_input && (
                            <small className="text-danger">
                              {errors.number_of_seats_input}
                            </small>
                          )}
                        </div>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="number_of_cabins_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails.number_of_cabins_input ||
                              ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_cabins_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_cabins_input"
                            className="floating-label"
                          >
                            Number of Cabins
                          </label>
                          {errors.number_of_cabins_input && (
                            <small className="text-danger">
                              {errors.number_of_cabins_input}
                            </small>
                          )}
                        </div>
                      </div>
                      <div
                        className={`formRow mt-4 ${
                          errors.number_of_meeting_rooms_input ||
                          errors.conference_room
                            ? "mb-5"
                            : "mb-3"
                        }`}
                      >
                        <div className="input-container d-grid w-50">
                          <input
                            type="text"
                            id="number_of_meeting_rooms_input"
                            placeholder=" "
                            value={
                              formData.propertyDetails
                                .number_of_meeting_rooms_input || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "number_of_meeting_rooms_input",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="number_of_meeting_rooms_input"
                            className="floating-label"
                          >
                            Number of Meeting Room
                          </label>
                          {errors.number_of_meeting_rooms_input && (
                            <small className="text-danger">
                              {errors.number_of_meeting_rooms_input}
                            </small>
                          )}
                        </div>
                        <div className="input-container d-grid w-50">
                          <input
                            type="text"
                            id="conference_room"
                            placeholder=" "
                            value={
                              formData.propertyDetails.conference_room || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "conference_room",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="conference_room"
                            className="floating-label"
                          >
                            Conference Room
                          </label>
                          {errors.conference_room && (
                            <small className="text-danger">
                              {errors.conference_room}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              {["retailshop", "showroom"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                <button
                                  className="add-new-btn"
                                  // onClick={() => handleAddProjectSelect(projectInput)}
                                  onClick={() =>
                                    window.open("/addProject", "_blank")
                                  }
                                >
                                  + Add New
                                </button>
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.property_age ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["under_construction"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.possession_date ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="date"
                            id="possession_date"
                            placeholder=" "
                            value={
                              formData.propertyDetails.possession_date || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "possession_date",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="possession_date"
                            className="floating-label"
                          >
                            Possession Date{" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.possession_date && (
                            <small className="text-danger">
                              {errors.possession_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow mt-4 ${
                      errors.suitable_for || errors.carpet_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="d-grid w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"suitable_for"}
                        options={suitableOption}
                        placeholder="Select Suitable For"
                        onSelect={(value) =>
                          console.log("suitable for:", value)
                        }
                      />
                      {errors.suitable_for && (
                        <small className="text-danger">
                          {errors.suitable_for}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["warehouse"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                <button
                                  className="add-new-btn"
                                  // onClick={() => handleAddProjectSelect(projectInput)}
                                  onClick={() =>
                                    window.open("/addProject", "_blank")
                                  }
                                >
                                  + Add New
                                </button>
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.property_age ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["under_construction"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.possession_date ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="date"
                            id="possession_date"
                            placeholder=" "
                            value={
                              formData.propertyDetails.possession_date || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "possession_date",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="possession_date"
                            className="floating-label"
                          >
                            Possession Date{" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.possession_date && (
                            <small className="text-danger">
                              {errors.possession_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.carpet_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              {["plot"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                <button
                                  className="add-new-btn"
                                  // onClick={() => handleAddProjectSelect(projectInput)}
                                  onClick={() =>
                                    window.open("/addProject", "_blank")
                                  }
                                >
                                  + Add New
                                </button>
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.plot_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="plot_area"
                        placeholder=" "
                        value={formData.propertyDetails.plot_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "plot_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="plot_area" className="floating-label">
                        Plot Area <span className="required_field">*</span>
                      </label>
                      {errors.plot_area && (
                        <small className="text-danger">
                          {errors.plot_area}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              {["other"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                <button
                                  className="add-new-btn"
                                  // onClick={() => handleAddProjectSelect(projectInput)}
                                  onClick={() =>
                                    window.open("/addProject", "_blank")
                                  }
                                >
                                  + Add New
                                </button>
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow  mt-4 ${
                      errors.possession_status || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow  mt-4 ${
                          errors.property_age ? "mb-4" : "mb-4"
                        }`}
                      >
                        <div className="input-container d-grid w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["under_construction"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow  mt-4 ${
                          errors.possession_date ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container d-grid w-50">
                          <input
                            type="date"
                            id="possession_date"
                            placeholder=" "
                            value={
                              formData.propertyDetails.possession_date || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "possession_date",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="possession_date"
                            className="floating-label"
                          >
                            Possession Date{" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.possession_date && (
                            <small className="text-danger">
                              {errors.possession_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow  mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHubOption}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.carpet_area || errors.property_name
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>

                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="property_name"
                        placeholder=" "
                        value={formData.propertyDetails.property_name || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "property_name",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label htmlFor="property_name" className="floating-label">
                        Property Name <span className="required_field">*</span>
                      </label>
                      {errors.property_name && (
                        <small className="text-danger">
                          {errors.property_name}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div
                className={`formRow mt-4 ${
                  errors.pricing || errors.security_deposit_month
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container d-grid w-50">
                  <input
                    type="number"
                    id="pricing"
                    placeholder=" "
                    value={formData.propertyPrice.pricing || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyPrice",
                        "pricing",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pricing" className="floating-label">
                    Price <span className="required_field">*</span>
                  </label>
                  {errors.pricing && (
                    <small className="text-danger">{errors.pricing}</small>
                  )}
                </div>

                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyPrice"}
                    field={"security_deposit_month"}
                    options={securityDepositOption}
                    placeholder="Select Security Deposit"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("security deposit:", value)
                    }
                  />
                  {errors.security_deposit_month && (
                    <small className="text-danger">
                      {errors.security_deposit_month}
                    </small>
                  )}
                </div>
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.security_deposit_amount ? "mb-5" : "mb-3"
                }`}
              >
                {["custom"].includes(
                  formData.propertyPrice.security_deposit_month
                ) && (
                  <>
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="security_deposit"
                        placeholder=""
                        value={
                          formData.propertyPrice.security_deposit_amount || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "propertyPrice",
                            "security_deposit_amount",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="security_deposit"
                        className="floating-label"
                      >
                        Security Deposit Amount{" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.security_deposit_amount && (
                        <small className="text-danger">
                          {errors.security_deposit_amount}
                        </small>
                      )}
                    </div>
                  </>
                )}
              </div>
              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
  // Input field for role (Buy/Owner) in Commercial Sell category
  else if (
    selfType === 5 &&
    propertyType === "commercial" &&
    propertyService === "sell"
  ) {
    switch (activeStep) {
      case 1:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Property Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody">
              <div
                className={`formRow  mt-4 ${
                  errors.property_type ? "mb-4" : "mb-4"
                }`}
              >
                <div className=" w-100">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyDetails"}
                    field={"property_type"}
                    options={commercialPropertyType}
                    placeholder="Select Property Type"
                    required={"1"}
                    onSelect={(value) => console.log("property type:", value)}
                  />
                  {errors.property_type && (
                    <small className="text-danger">
                      {errors.property_type}
                    </small>
                  )}
                </div>
              </div>

              {["office"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}
                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                {/* <button
                                className="add-new-btn"
                                onClick={() => handleAddProjectSelect(projectInput)}
                              >
                                + Add New
                              </button> */}
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                  </div>

                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.property_age ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["under_construction"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.possession_date ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="date"
                            id="possession_date"
                            placeholder=" "
                            value={
                              formData.propertyDetails.possession_date || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "possession_date",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="possession_date"
                            className="floating-label"
                          >
                            Possession Date{" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.possession_date && (
                            <small className="text-danger">
                              {errors.possession_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHubOption}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.property_condition || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"property_condition"}
                        options={propertyConditionOption}
                        placeholder="Select Property Condition"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("property condition:", value)
                        }
                      />
                      {errors.property_condition && (
                        <small className="text-danger">
                          {errors.property_condition}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>

                  <div
                    className={`formRow mt-4 ${
                      errors.carpet_area || errors.construction_status
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    {["ready_use"].includes(
                      formData.propertyDetails.property_condition
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="carpet_area"
                            placeholder=" "
                            value={formData.propertyDetails.carpet_area || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "carpet_area",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="carpet_area"
                            className="floating-label"
                          >
                            Carpet Area(in sq.ft.){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.carpet_area && (
                            <small className="text-danger">
                              {errors.carpet_area}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                    {["bare_shell"].includes(
                      formData.propertyDetails.property_condition
                    ) && (
                      <>
                        <div className="w-50">
                          <CustomDropdown
                            formData={formData}
                            handleInputChange={handleInputChange}
                            index={"propertyDetails"}
                            field={"construction_status"}
                            options={constructionStatusOption}
                            placeholder="Select Construction Status"
                            required={"1"}
                            onSelect={(value) =>
                              console.log("construction status:", value)
                            }
                          />
                          {errors.construction_status && (
                            <small className="text-danger">
                              {errors.construction_status}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["retailshop", "showroom"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                {/* <button
                                className="add-new-btn"
                                onClick={() => handleAddProjectSelect(projectInput)}
                              >
                                + Add New
                              </button> */}
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.available_from
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>

                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.property_age ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["under_construction"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.possession_date ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="date"
                            id="possession_date"
                            placeholder=" "
                            value={
                              formData.propertyDetails.possession_date || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "possession_date",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="possession_date"
                            className="floating-label"
                          >
                            Possession Date{" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.possession_date && (
                            <small className="text-danger">
                              {errors.possession_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.carpet_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}

              {["warehouse"].includes(
                formData.propertyDetails.property_type
              ) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                {/* <button
                                  className="add-new-btn"
                                  onClick={() => handleAddProjectSelect(projectInput)}
                                >
                                  + Add New
                                </button> */}
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.possession_status || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.property_age ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["under_construction"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow mt-4 ${
                          errors.possession_date ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container w-50">
                          <input
                            type="date"
                            id="possession_date"
                            placeholder=" "
                            value={
                              formData.propertyDetails.possession_date || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "possession_date",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="possession_date"
                            className="floating-label"
                          >
                            Possession Date{" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.possession_date && (
                            <small className="text-danger">
                              {errors.possession_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHub2Option}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.carpet_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              {["plot"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                {/* <button
                                className="add-new-btn"
                                onClick={() => handleAddProjectSelect(projectInput)}
                              >
                                + Add New
                              </button> */}
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.plot_area ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="plot_area"
                        placeholder=" "
                        value={formData.propertyDetails.plot_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "plot_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="plot_area" className="floating-label">
                        Plot Area <span className="required_field">*</span>
                      </label>
                      {errors.plot_area && (
                        <small className="text-danger">
                          {errors.plot_area}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              {["other"].includes(formData.propertyDetails.property_type) && (
                <>
                  <div
                    className={`formRow  mt-4 ${
                      errors.sub_locality_id || errors.projectInput
                        ? "mb-4"
                        : "mb-4"
                    }`}
                  >
                    <div className="input-container w-50">
                      <div className="input-wrapper">
                        <input
                          type="text"
                          id="localityInput"
                          placeholder=" "
                          value={localityInput}
                          onChange={handleLocalityInputChange}
                          className="textField"
                        />
                        <label
                          htmlFor="localityInput"
                          className="floating-label"
                        >
                          Locality (Optional)
                        </label>
                      </div>

                      {loadingLocalities && (
                        <div className="loading">Loading localities...</div>
                      )}

                      {showLocalityDropdown && localities.length > 0 && (
                        <ul className="autocomplete-dropdown">
                          {localities.map((locality) => (
                            <li
                              key={locality.id}
                              className="autocomplete-item"
                              onClick={() => handleLocalitySelect(locality)}
                            >
                              {locality.title}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.sub_locality_id && (
                        <small className="text-danger">
                          {errors.sub_locality_id}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <div className="autocomplete-container">
                        {/* Project Dropdown */}
                        <div className="input-wrapper">
                          <input
                            type="text"
                            id="buildingInput"
                            placeholder=" "
                            // value={formData.propertyDetails.building || ''}
                            value={projectInput}
                            // onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
                            onChange={handleProjectInputChange}
                            className="textField"
                          />
                          <label
                            htmlFor="buildingInput"
                            className="floating-label"
                          >
                            Building/Project/Society (Optional)
                          </label>
                        </div>

                        {loadingProjects && (
                          <div className="loading">Loading projects...</div>
                        )}

                        {showProjectDropdown && projectInput?.length >= 1 && (
                          <ul className="autocomplete-dropdown">
                            {projects.length === 0 ? ( // ✅ Only check for empty array
                              <li className="autocomplete-item no-results">
                                No results found
                                {/* <button
                                className="add-new-btn"
                                onClick={() => handleAddProjectSelect(projectInput)}
                              >
                                + Add New
                              </button> */}
                              </li>
                            ) : (
                              projects.map((project) => (
                                <li
                                  key={project.id}
                                  className="autocomplete-item"
                                  onClick={() => handleProjectSelect(project)}
                                >
                                  {project.name}
                                </li>
                              ))
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={`formRow  mt-4 ${
                      errors.possession_status || errors.buildup_area
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50 ">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"possession_status"}
                        options={possessionStatusOption}
                        placeholder="Select Possession Status"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("possession status:", value)
                        }
                      />
                      {errors.possession_status && (
                        <small className="text-danger">
                          {errors.possession_status}
                        </small>
                      )}
                    </div>
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="builtupArea"
                        placeholder=" "
                        value={formData.propertyDetails.buildup_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "buildup_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="builtupArea" className="floating-label">
                        Built Up Area (Sq. Ft){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.buildup_area && (
                        <small className="text-danger">
                          {errors.buildup_area}
                        </small>
                      )}
                    </div>
                  </div>
                  {["ready_to_use"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow  mt-4 ${
                          errors.property_age ? "mb-4" : "mb-4"
                        }`}
                      >
                        <div className="input-container d-grid w-50">
                          <input
                            type="text"
                            id="property_age"
                            placeholder=" "
                            value={formData.propertyDetails.property_age || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "property_age",
                                e.target.value
                              )
                            }
                            onInput={(e) =>
                              (e.target.value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              ))
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="property_age"
                            className="floating-label"
                          >
                            Age of Property(in years){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.property_age && (
                            <small className="text-danger">
                              {errors.property_age}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {["under_construction"].includes(
                    formData.propertyDetails.possession_status
                  ) && (
                    <>
                      <div
                        className={`formRow  mt-4 ${
                          errors.possession_date ? "mb-5" : "mb-3"
                        }`}
                      >
                        <div className="input-container d-grid w-50">
                          <input
                            type="date"
                            id="possession_date"
                            placeholder=" "
                            value={
                              formData.propertyDetails.possession_date || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "possession_date",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="possession_date"
                            className="floating-label"
                          >
                            Possession Date{" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.possession_date && (
                            <small className="text-danger">
                              {errors.possession_date}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div
                    className={`formRow  mt-4 ${
                      errors.zone_type || errors.ownership ? "mb-5" : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"zone_type"}
                        options={zoneTypeOption}
                        placeholder="Select Zone Type"
                        required={"1"}
                        onSelect={(value) => console.log("zone type:", value)}
                      />
                      {errors.zone_type && (
                        <small className="text-danger">
                          {errors.zone_type}
                        </small>
                      )}
                    </div>
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"ownership"}
                        options={ownershipOption}
                        placeholder="Select Ownership Type"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("ownership type:", value)
                        }
                      />
                      {errors.ownership && (
                        <small className="text-danger">
                          {errors.ownership}
                        </small>
                      )}
                    </div>
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.location_hub || errors.other_location_hub
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="w-50">
                      <CustomDropdown
                        formData={formData}
                        handleInputChange={handleInputChange}
                        index={"propertyDetails"}
                        field={"location_hub"}
                        options={locationHubOption}
                        placeholder="Select Location Hub"
                        required={"1"}
                        onSelect={(value) =>
                          console.log("location hub:", value)
                        }
                      />
                      {errors.location_hub && (
                        <small className="text-danger">
                          {errors.location_hub}
                        </small>
                      )}
                    </div>
                    {["others"].includes(
                      formData.propertyDetails.location_hub
                    ) && (
                      <>
                        <div className="input-container w-50">
                          <input
                            type="text"
                            id="other_location_hub"
                            placeholder=" "
                            value={
                              formData.propertyDetails.other_location_hub || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "propertyDetails",
                                "other_location_hub",
                                e.target.value
                              )
                            }
                            className="textField"
                          />
                          <label
                            htmlFor="other_location_hub"
                            className="floating-label"
                          >
                            Others(Location Hub){" "}
                            <span className="required_field">*</span>
                          </label>
                          {errors.other_location_hub && (
                            <small className="text-danger">
                              {errors.other_location_hub}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`formRow mt-4 ${
                      errors.carpet_area || errors.property_name
                        ? "mb-5"
                        : "mb-3"
                    }`}
                  >
                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="carpet_area"
                        placeholder=" "
                        value={formData.propertyDetails.carpet_area || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "carpet_area",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label htmlFor="carpet_area" className="floating-label">
                        Carpet Area(in sq.ft.){" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.carpet_area && (
                        <small className="text-danger">
                          {errors.carpet_area}
                        </small>
                      )}
                    </div>

                    <div className="input-container w-50">
                      <input
                        type="text"
                        id="property_name"
                        placeholder=" "
                        value={formData.propertyDetails.property_name || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "property_name",
                            e.target.value
                          )
                        }
                        className="textField"
                      />
                      <label htmlFor="property_name" className="floating-label">
                        Property Name <span className="required_field">*</span>
                      </label>
                      {errors.property_name && (
                        <small className="text-danger">
                          {errors.property_name}
                        </small>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="amenities">
                <h6
                  onClick={openModal}
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  + Add Furnishings / Amenities
                </h6>
                {formData.propertyDetails.amenities_furnishes && (
                  <div className="amenities_1">
                    <span>Flat Furnishings:</span>{" "}
                    {formData.propertyDetails.amenities_furnishes}
                    <br />
                  </div>
                )}
                {formData.propertyDetails.amenities_society && (
                  <div className="amenities_1">
                    <span>Society Amenities:</span>{" "}
                    {formData.propertyDetails.amenities_society}
                    <br />
                  </div>
                )}
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
            {(isModalOpen || emitterEvent) && (
              <AmenitiesModal
                closeModal={closeModal}
                emitterEvent={emitterEvent}
                handleInputChange={handleInputChange}
                formData={formData}
              />
            )}
          </div>
        );
      case 2:
        return (
          <div className="forms">
            <div className="formHeader">
              <span>Add Price Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBody2">
              <div
                className={`formRow mt-4 ${
                  errors.pricing || errors.security_deposit_month
                    ? "mb-5"
                    : "mb-3"
                }`}
              >
                <div className="input-container d-grid w-50">
                  <input
                    type="number"
                    id="pricing"
                    placeholder=" "
                    value={formData.propertyPrice.pricing || ""}
                    onChange={(e) =>
                      handleInputChange(
                        "propertyPrice",
                        "pricing",
                        e.target.value
                      )
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="textField"
                  />
                  <label htmlFor="pricing" className="floating-label">
                    Price <span className="required_field">*</span>
                  </label>
                  {errors.pricing && (
                    <small className="text-danger">{errors.pricing}</small>
                  )}
                </div>

                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"propertyPrice"}
                    field={"security_deposit_month"}
                    options={securityDepositOption}
                    placeholder="Select Security Deposit"
                    required={"1"}
                    onSelect={(value) =>
                      console.log("security deposit:", value)
                    }
                  />
                  {errors.security_deposit_month && (
                    <small className="text-danger">
                      {errors.security_deposit_month}
                    </small>
                  )}
                </div>
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.security_deposit_amount ? "mb-5" : "mb-3"
                }`}
              >
                {["custom"].includes(
                  formData.propertyPrice.security_deposit_month
                ) && (
                  <>
                    <div className="input-container d-grid w-50">
                      <input
                        type="text"
                        id="security_deposit"
                        placeholder=""
                        value={
                          formData.propertyPrice.security_deposit_amount || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "propertyPrice",
                            "security_deposit_amount",
                            e.target.value
                          )
                        }
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                        }
                        className="textField"
                      />
                      <label
                        htmlFor="security_deposit"
                        className="floating-label"
                      >
                        Security Deposit Amount{" "}
                        <span className="required_field">*</span>
                      </label>
                      {errors.security_deposit_amount && (
                        <small className="text-danger">
                          {errors.security_deposit_amount}
                        </small>
                      )}
                    </div>
                  </>
                )}
              </div>
              <form onSubmit={handleSubmit}>
                <div className="ribbon1">
                  <button className="ribbonText">
                    {listingId ? "Update Property" : "Post Property"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        );
    }
  }
};

export default PropertyDetailForm;
